export const orderedSizes = [
    "univerzalna",
    "XXXS",
    "XXS",
    "XS",
    "small",
    "S",
    "O/S",
    "2/S",
    "S/M",
    "M",
    "3/M",
    "L",
    "4/L",
    "L/XL",
    "XL",
    "5/XL",
    "XXL",
    "XXXL",
    "Z",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "34.5",
    "34,5",
    "35",
    "35.5",
    "35,5",
    "36",
    "36.5",
    "36,5",
    "37",
    "37.5",
    "37,5",
    "38",
    "38.5",
    "38,5",
    "39",
    "39.5",
    "39,5",
    "40",
    "40.5",
    "40,5",
    "41",
    "41.5",
    "41,5",
    "42",
    "42.5",
    "42,5",
    "43",
    "43.5",
    "43,5",
    "44",
    "44.5",
    "44,5",
    "45",
    "45.5",
    "45,5",
    "46",
    "48",
    "50",
    "52",
    "65B",
    "65 B",
    "70B",
    "70 B",
    "70 C",
    "70 D",
    "70E",
    "75B",
    "75 B",
    "75 C",
    "75 D",
    "75E",
    "75 E",
    "80B",
    "80 B",
    "80 C",
    "80 D",
    "80E",
    "80 E",
    "85B",
    "85 B",
    "85 C",
    "85 D",
    "85E",
    "85 E",
    "90B",
    "90 B",
    "90 C",
    "90 D",
    "90 E",
    "35/38",
    "36/37",
    "38/39",
    "39/42",
    "40/41",
    "70x140 cm",
    "120x160",
    "16x11x12 cm",
    "19x9x15 cm",
    "20x7,5x13 cm",
    "22x6,5x14 cm",
    "22,5x14,5x6,5 cm",
    "23x10,5x15 cm",
    "24x8x18 cm",
    "26x11x15,5 cm",
  ]
  